import React from 'react';
import { useParams } from 'react-router-dom';
import BlogNotFoundPage from './BlogNotFoundPage';
import NoFrillsBlogPage from './posts/NoFrillsBlogPage';
import PhilzCoffeeBlogPage from './posts/PhilzCoffeeBlogPage';
import PapaJohnsBlogPage from './posts/PapaJohnsBlogPage';

export default function BlogPostRouterPage() {
  const { slug } = useParams<{ slug: string }>();

  switch (slug) {
    case 'no-frills':
      return <NoFrillsBlogPage />;
    case 'philz-coffee':
      return <PhilzCoffeeBlogPage />;
    case 'papajohns':
      return <PapaJohnsBlogPage />;
    default:
      return <BlogNotFoundPage />;
  }
}

